import { useState } from 'react';
import BrandLogo from './BrandLogo';
import PosExpiredCard from './PosExpiredCard';
import PosSubscribeModal from './PosSubscribeModal';
import { BRAND_LOGO_URL } from '../constants/bookingConst';
import { POS_SUBSCRIPTION_VENDOR_NAME } from '../constants/posConst';
import '../css/Pos.css';
import '../css/PosSubscription.css';

/**
 * What a till shows INSTEAD OF EVERYTHING ELSE — the sign-in card included —
 * while an administrator has DISABLED the client by hand.
 *
 * Shown before sign-in on purpose: a disabled till has nothing behind the
 * sign-in card to offer, and asking staff for a password only to then say "no"
 * would be a worse experience than saying so up front.
 *
 * It still lets the club RENEW from here, since that is the one thing that
 * gets them back in. Once the renewal is approved the till re-opens by itself
 * — approval removes the disabled flag and this screen is listening for it.
 *
 * (An expired plan that nobody disabled is handled by PosExpiredLock, which
 * shows the same card over the till.)
 *
 * @returns {JSX.Element}
 */
function PosClientDisabledScreen() {
  const [renewing, setRenewing] = useState(false);

  return (
    <div className="ps-lock">
      <PosExpiredCard onRenew={() => setRenewing(true)} />

      <p className="ps-lock-powered">
        <BrandLogo src={BRAND_LOGO_URL} alt="" className="ps-lock-powered-logo" />
        {POS_SUBSCRIPTION_VENDOR_NAME}
      </p>

      <PosSubscribeModal isOpen={renewing} onClose={() => setRenewing(false)} />
    </div>
  );
}

export default PosClientDisabledScreen;
